
























import Vue from "vue";
import UserAvatar from "../common/user-avatar.vue";

export default Vue.extend({
  name: "ChangePrimaryOwner",
  components: { UserAvatar },
  props: {
    newPrimaryOwnerId: Number,
    show: Boolean,
  },
  data() {
    return {
      changePrimaryOwnerModel: {
        updateInvoiceEmail: false,
      },
    };
  },
  computed: {
    showModal(): any {
      return this.show;
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.changePrimaryOwnerModel.updateInvoiceEmail = false;
      }
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleSave(event) {
      this.$emit("change", { newPrimaryOwnerId: this.newPrimaryOwnerId, updateInvoiceEmail: this.changePrimaryOwnerModel.updateInvoiceEmail });
    },
  },
});
